<template>
  <v-container fluid style="height: 100%; padding-bottom: 125px">
      <v-row>
        <v-col
        sm="4"
        lg="3"
        cols="12"
        style="padding-bottom: 20px; max-height: 60px"
      >
        <v-text-field
          solo
          :label="$t('search')"
          append-icon="mdi-magnify"
          single-line
          v-model="search"
          :color="colorTheme"
        ></v-text-field>
      </v-col>
      <v-col sm="4" md="3" lg="2" cols="12" style="padding-bottom: 20px">
        <v-btn
          style="width: 100%; margin: 0"
          large
          :color="colorTheme"
          class="white--text"
          v-on:click="mixValues()"
          v-if="isMixed == false"
        >
          {{ $t("mix").toUpperCase() }}
        </v-btn>
        <v-btn
          style="width: 100%; margin: 0"
          large
          :color="colorTheme"
          class="white--text"
          v-on:click="splitValues()"
          v-else
        >
          {{ $t("split").toUpperCase() }}
        </v-btn>
      </v-col>
      
      <v-col cols="12" align="left">
        <h3 style="font-weight: 500">
          {{ title }}
        </h3>
      </v-col>
      <v-col lg="12" md="12" sm="12" cols="12">
          <v-data-table
          :headers="isMixed ? headersCompareMix : headersCompare"
          :items="comparedItems"
          :items-per-page="-1"
          :item-class="itemRowBackground"
          hide-default-footer
          item-key="name"
          sort-by="name"
          group-by="category"
          :groupDesc="true"
          class="elevation-1"
          :search="search"
          :loading="loadingComparativeTable"
          :loading-text="$t('loadingTextForTable')"
          :no-data-text="$t('noResults')"
          :mobile-breakpoint="isMixed ? '715' : '600'"
        >
          <template v-slot:group.header="{ group, headers, isOpen, toggle }">
            <td :colspan="headers.length" class="text-left">
              <v-btn icon small @click="toggle">
                <v-icon v-if="isOpen">mdi-minus</v-icon>
                <v-icon v-else>mdi-plus</v-icon>
              </v-btn>
              {{ group }}
            </td>
          </template>

          <template v-slot:item.contentTemp="{ item }" v-if="isMixed">
            <td v-if="item.distinct">
              <v-row align="center" justify="center">
                <v-radio-group dense v-model="item.mix" @change="getObj(item)" class="labelVC">
                  <v-radio :value="item.contentTemp" :label="item.contentTemp"></v-radio>
                </v-radio-group>
              </v-row>
            </td>
            <td v-else>
              {{ item.contentTemp }}
            </td>
          </template>

          <template v-slot:item.contentVeh="{ item }" v-if="isMixed">
            <td v-if="item.distinct">
              <v-row align="center" justify="center">
                <v-radio-group dense v-model="item.mix" @change="getObj(item)" class="labelVC">
                  <v-radio :value="item.contentVeh" :label="item.contentVeh"></v-radio>
                </v-radio-group>
              </v-row>
            </td>
            <td v-else>
              {{ item.contentVeh }}
            </td>
          </template>

          <template v-slot:body.append v-if="$vuetify.breakpoint.xs == false">
          <tr>
            <td></td>
            <td>
              <v-btn
              style="width: 130px; margin: 0"
              large
              :icon="$vuetify.breakpoint.smAndDown"
              :color="colorTheme"
              v-on:click="openSync(true)"
              >
              <div v-if="$vuetify.breakpoint.mdAndUp" class="white--text">{{ $t("sync").toUpperCase() }}</div>
              <v-icon v-if="$vuetify.breakpoint.smAndDown">mdi-cog-transfer</v-icon>
            </v-btn>
            </td>
            <td>
              <v-btn
              style="width: 130px; margin: 0"
              large
              :icon="$vuetify.breakpoint.smAndDown"
              :color="colorTheme"
              v-on:click="openSync(false)"
              >
              <div v-if="$vuetify.breakpoint.mdAndUp" class="white--text">{{ $t("sync").toUpperCase() }}</div>
              <v-icon v-if="$vuetify.breakpoint.smAndDown">mdi-cog-transfer</v-icon>
            </v-btn>
            </td>
            <td v-if="isMixed">
              <v-btn
              style="width: 130px; margin: 0"
              large
              :icon="$vuetify.breakpoint.smAndDown"
              :color="colorTheme"
              v-on:click="openSync(false)"
              >
              <div v-if="$vuetify.breakpoint.mdAndUp" class="white--text">{{ $t("sync").toUpperCase() }}</div>
              <v-icon v-if="$vuetify.breakpoint.smAndDown">mdi-cog-transfer</v-icon>
            </v-btn>
            </td>
          </tr>
        </template>
        </v-data-table>
        <v-col sm="4" cols="12" style="padding-bottom: 20px" v-if="$vuetify.breakpoint.xs">
          <v-btn
            style="width: 100%; margin: 0"
            large
            :color="colorTheme"
            class="white--text"
            v-on:click="openSync(true)"
          >
            {{ $t("sync").toUpperCase() }} {{ $t("withThe").toUpperCase() }} {{ $t("templateContent").toUpperCase() }}
          </v-btn>
        </v-col>
        <v-col sm="4" cols="12" style="padding-bottom: 20px" v-if="$vuetify.breakpoint.xs">
          <v-btn
            style="width: 100%; margin: 0"
            large
            :color="colorTheme"
            class="white--text"
            v-on:click="openSync(false)"
          >
            {{ $t("sync").toUpperCase() }} {{ $t("withThe").toUpperCase() }} {{ $t("vehicleContent").toUpperCase() }}
          </v-btn>
        </v-col>
        <v-col sm="4" cols="12" style="padding-bottom: 20px" v-if="$vuetify.breakpoint.xs && isMixed">
          <v-btn
            style="width: 100%; margin: 0"
            large
            :color="colorTheme"
            class="white--text"
            v-on:click="openSync(false)"
          >
            {{ $t("sync").toUpperCase() }} {{ $t("withThe").toUpperCase() }} {{ $t("preliminaryContent").toUpperCase() }}
          </v-btn>
        </v-col>

      </v-col>
      <v-dialog v-model="dialogSync" hide-overlay persistent width="500px">
        <v-card>
          <v-card-title>
            {{ $t("sync") }}
            <v-spacer></v-spacer>
            <v-btn icon color="black" @click="dialogSync = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider :color="colorTheme" style="border-width: 2px"></v-divider>
          <v-card-text
            style="padding-top: 11px; color: black"
            class="text-left"
            v-if="syncVehWithTemp"
            >{{ textforVehWithTemp }}</v-card-text
          >
          <v-card-text
            style="padding-top: 11px; color: black"
            class="text-left"
            v-else
            >{{ textforTempWithVeh }}</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text :color="colorTheme" @click="dialogSync = false">{{
              $t("cancel").toUpperCase()
            }}</v-btn>
            <v-btn text :color="colorTheme" @click="sync()">{{
              $t("accept").toUpperCase()
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogConfirm" hide-overlay persistent width="500px">
        <v-card>
          <v-card-title>
            {{ $t("confirmationT") }}
            <v-spacer></v-spacer>
            <v-btn icon color="black" @click="dialogConfirm = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :color="colorTheme" style="border-width: 2px"></v-divider>
          <v-card-text
            style="padding-top: 11px; color: black"
            class="text-left"
            >
            <div class="my-2">{{ confirmText }} </div>
            <div>{{ $t("toContinue") }} </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text :color="colorTheme" @click="dialogConfirm = false">{{
              $t("cancel").toUpperCase()
            }}</v-btn>
            <v-btn text :color="colorTheme" @click="openAssignTemp()">{{
              $t("accept").toUpperCase()
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </v-row>
  </v-container>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
export default {
  name: "verifyConfiguration",
  data() {
    return {
      search: "",
      dialogConfirm: false,
      dialogSync: false,
      item: "",
      title: "",
      syncVehWithTemp: true,
      textforVehWithTemp: "",
      textforTempWithVeh: "",
      confirmText: "",
      tempContent: [],
      vehContent: [],
      mixedChoice: [],
      isMixed: false
    };
  },
  created() {
    this.$store.commit("setTitle", "ALERTRUCK");
    this.$store.commit("setPageHeader", [
      this.$t("parametersConfig").toUpperCase(),
      this.$t("verifyConfig").toUpperCase(),
      "",
      "",
      true
    ]);
  },
  mounted() {
    this.$store.dispatch("contentVehicleAT");
    this.item = this.$store.state.selectedVehAT == "" ? JSON.parse(localStorage.getItem("selectedVehAT")) : this.$store.state.selectedVehAT;
    var name = this.item.Template;
    if (name == i18n.t("default")) {
      name = i18n.t("defaultTemplate")
    }
    this.title = name.toUpperCase() + " vs " + this.item.Nick + " (" + this.item.MovilId + ")" ;
  },
  watch: {
    mixedChoice() {
      var value = this.mixedChoice;
      console.log(value);
    }
  },
  computed: {
    ...mapState([
      "colorTheme",
      "comparedItems",
      "loadingComparativeTable",
      "templateName",
    ]),
    //se necesita tener headersCompare y headersCompareMix en computed por el width responsivo
    //se usa un header vacio con width responsivo para que la tabla no se extienda en todo lo ancho ya que solo son 3 o 4 columnas
    headersCompare() {
      return [
        {
          text: i18n.t("parameter").toUpperCase(),
          value: "name"
        },
        {
          text: i18n.t("templateContent").toUpperCase(),
          value: "contentTemp",
          align: "center"
        },
        {
          text: i18n.t("vehicleContent").toUpperCase(),
          value: "contentVeh",
          align: "center"
        },
        { text: '', value: "emptyForSpace", width: this.widthForHeadersCompare, sortable: false },
      ]
    },
    //se utiliza computed para estar calculando el width del header vacio dependiendo del breakpoint
    widthForHeadersCompare() {
      if (this.$vuetify.breakpoint.width > 1400) {
        return '50%'
      } else if (this.$vuetify.breakpoint.width < 1400 && this.$vuetify.breakpoint.width > 1263) {
        return '40%'
      } else {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '0%'
          case 'sm': return '0%'
          case 'md': return '24%'
        }
      }
    },
    headersCompareMix() {
      return [
        {
          text: i18n.t("parameter").toUpperCase(),
          value: "name"
        },
        {
          text: i18n.t("templateContent").toUpperCase(),
          value: "contentTemp",
          align: "center"
        },
        {
          text: i18n.t("vehicleContent").toUpperCase(),
          value: "contentVeh",
          align: "center"
        },
        {
          text: i18n.t("preliminaryContent").toUpperCase(),
          value: "mix",
          align: "center"
        },
        { text: '', value: '', width: this.widthForHeadersCompareMix, sortable: false },
      ]
    },
    widthForHeadersCompareMix() {
      if (this.$vuetify.breakpoint.width > 1400) {
        return '40%'
      } else if (this.$vuetify.breakpoint.width < 1400 && this.$vuetify.breakpoint.width > 1263) {
        return '30%'
      } else {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '0%'
          case 'sm': return '0%'
          case 'md': return '18%'
        }
      }
    },
  },
  methods: {
    openConfirm() {
      var name = this.item.Template;
      if (name == i18n.t("default")) {
        name = i18n.t("defaultTemplate")
      }
      this.confirmText = i18n.t("overwritingThe") + " " +  name.toUpperCase() + " " + i18n.t("requiredTo").toLowerCase()+ ".";
      this.dialogConfirm = true;
    },
    openSync(val) {
      var name = this.item.Template;
      if (name == i18n.t("default")) {
        name = i18n.t("defaultTemplate")
      }
      if (val) {
        if (i18n.locale == "es") {
          this.textforVehWithTemp = "¿" + i18n.t("sync") + " " + this.item.Nick + " (" + this.item.MovilId + ") " + i18n.t("with").toLowerCase() + " " + name.toUpperCase() + "?";
        } else {
          this.textforVehWithTemp = i18n.t("sync") + " " + this.item.Nick + " (" + this.item.MovilId + ") " + i18n.t("with").toLowerCase() + " " + name.toUpperCase() + "?";
        }
        
      } else {
        if (i18n.locale == "es") {
          this.textforTempWithVeh = "¿" + i18n.t("sync") + " " + name.toUpperCase()  + " " + i18n.t("withThe").toLowerCase() + " " + i18n.t("vehicleContent").toLowerCase() + "?";
        } else {
          this.textforTempWithVeh = i18n.t("sync") + " " + name.toUpperCase()  + " " + i18n.t("withThe").toLowerCase() + " " + i18n.t("vehicleContent").toLowerCase() + "?";
        }
      }
      this.syncVehWithTemp = val;
      this.dialogSync = true;
    },
    openAssignTemp() {
      this.dialogConfirm = false;
    },
    sync() {
      var name = this.item.Template;
      if (name == i18n.t("default")) {
          name = i18n.t("defaultTemplate")
      }
      if (this.syncVehWithTemp) {
        this.dialogSync = false;
        this.$router.back();
        //se forma el objeto para enviarlo y recibirlo despues
        var obj = {
          icon: "mdi-file-upload-outline",
          title: "Configuración de parámetros en progreso",
          subtitle: this.item.Nick + " (" + this.item.MovilId + ") " + i18n.t("with").toLowerCase() + " " + name.toUpperCase()
        };
        //this.$store.state.client.send('/topic/test', {"content-type":"text/plain"}, JSON.stringify(obj));
      } else {
        this.confirmText = i18n.t("overwritingThe") + " " +  name.toUpperCase() + " " + i18n.t("requiredTo").toLowerCase();
        this.dialogSync = false;
        this.dialogConfirm = true;
      }
    },
    itemRowBackground: function (item) {
      if (item.distinct) {
        return 'rowColorVC';
      }
    },
    mixValues() {
      this.isMixed = true;
    },
    splitValues() {
      this.isMixed = false;
    },
    getObj(item) {
      console.log(item);
    }
  }
};
</script>

<style>
.rowColorVC {
  background-color: rgba(255, 66, 66, 0.21);
}
.labelVC.theme--light label {
  color: #000000DE;
}
.labelVC.theme--dark label {
  color: #fff;
}
.labelVC label {
  font-size: 14px;
}
</style>